import { CLOSE_REPORT_TOAST, OPEN_REPORT_TOAST, UPDATE_REPORT_TOAST, SET_DOWNLOADING_STATUS } from '../action/actionTypes';

const initialState = {
  isVisible: false,
  status: null, // 'started', 'processing', 'ready', 'error', 'timeout'
  reportPeriod: '',
  downloadUrl: null,
  isDownloading: false,
};

export default function reportToast(state = initialState, action) {
  switch (action.type) {
    case CLOSE_REPORT_TOAST:
      return {
        ...state,
        isVisible: false,
        status: null,
        reportPeriod: '',
        downloadUrl: null,
        isDownloading: false,
      };
    
    case OPEN_REPORT_TOAST:
      return {
        ...state,
        ...action.payload,
        isVisible: true,
        // Mantieni isDownloading se non viene specificato nel payload
        isDownloading: action.payload.isDownloading !== undefined ? action.payload.isDownloading : state.isDownloading,
      };
    
    case UPDATE_REPORT_TOAST:
      return {
        ...state,
        ...action.payload,
        // Mantieni isDownloading se non viene specificato nel payload
        isDownloading: action.payload.isDownloading !== undefined ? action.payload.isDownloading : state.isDownloading,
      };

    case SET_DOWNLOADING_STATUS:
      return {
        ...state,
        isDownloading: action.payload.isDownloading,
      };

    default:
      return state;
  }
} 